<template>
    <div class="w-full md:w-1/2 mb-16 px-6">
        <div class="mb-2 flex">
            <span class="w-1/2">
                <a href="#" @click.stop.prevent="showResourceDetail">Edit</a>
            </span>
            <span class="w-1/2 text-right">
                <a href="#" @click.stop.prevent="deleteResource">
                    Delete
                </a>
            </span>
        </div>
        <div v-if="resource.image">
            <a href="#" @click.stop.prevent="showResourceDetail">
                <img :src="resource.image + '?auto=format&fit=crop&h=619&w=1024'">
            </a>
        </div>
        <div v-else>
            <a href="#" @click.stop.prevent="showResourceDetail">
                <img alt="" src="/img/hems-placeholder.png">
            </a>
        </div>
        <div class="uppercase text-base text-gray-darker" v-if="published">Published</div>
        <div v-else>
            <template v-if="status == 'draft'">
                <span class="text-red text-base uppercase">Draft</span>
            </template>
            <template v-if="status == 'in review'">
                <span class="text-red text-base uppercase">In Review</span>
            </template>
            <template v-if="status == 'unpublished'">
                <span class="text-red text-base uppercase">Unpublished</span>
            </template>
        </div>
        <h2 class="text-1xl leading-tight mb-2 mt-1">
            <a class="text-n-gray-dark font-sans no-underline hover:underline" href="#"
                @click.stop.prevent="showResourceDetail">{{ resource.title }}
            </a>
        </h2>
        <div class="font-sans-italic mb-1 hosted-by" v-if="resource.organization">
            <span class="font-sans-bold-italic">
                {{ resource.organization.name }}
            </span>
        </div>

        <div class="text-base mb-5" v-html="resource.teaser"></div>

        <div class="uppercase" v-if="resource.tags" v-html="tagsHtml"></div>
    </div>
</template>

<script>

    import messaging from '../../mixins/messaging'

    export default {
        name: 'UserDashboardItem',
        mixins: [messaging],
        props: {
            resource: Object
        },
        components:{},
        data: () => ({

        }),
        computed: {
            tags() {
                return _.map(this.resource.tags, 'title')
            },
            tagsHtml() {
                return this.tags.join(' | ')
            },
            published() {
                return this.resource.published
            },
            status() {
                return this.resource.status
            }
        },
        watch: {},
        methods: {
            showResourceDetail() {
                this.$store.dispatch('setActiveResource', { data: this.resource })
                this.$router.push( {name: 'resource-basics', params: { id: this.resource.id }})
            },
            deleteResource() {
                var confirmed = confirm("Are you sure you want to delete this resource? Once deleted, you will not be able to undo.")

                if(confirmed) {
                    this.$toasted.show('Deleting resource...')

                    let route = this.$laroute.route('api.resources.destroy', { resource: this.resource.id })

                    axios.delete(route).then((response) => {
                        this.$store.dispatch('deleteResource', this.resource.id)
                        this.$toasted.show('Resource has been deleted')
                    }).catch((error) => {
                        this.displayError(error)
                    })
                }
            }
        },
        mounted() {}
    }
</script>
